// Server-side render output presets. Resolution and frame rate are no
// longer user-selectable: fps is derived automatically from the rotation
// speed (30fps at/below 120 RPM, 60fps above it) and resolution is fixed
// per preset to keep renders fast and consistently under the size cap.
export const ASPECT_PRESETS = {
  vertical: { w: 9, h: 16, width: 1080, height: 1920, label: 'Vertical 1080x1920 (Reels/TikTok)' },
  square: { w: 1, h: 1, width: 1080, height: 1080, label: 'Square 1080x1080 (Feed)' },
};
